export default __webpack_public_path__ + "static/image 1-5bdc581d0e87fab048938164118e054f.jpeg";